import { BannerRidgepoleWithLoader } from './loaders';

export const BannerRidgepole = () => <BannerRidgepoleWithLoader />;
